export enum DropoffPricingMode {
  Default = "default",
  Fixed = "fixed",
  Markup = "markup",
}
